import api from '@/api'
import Report from '@/api/communique/report'
import types from '@/types'

export interface OTTHoursWatchedStat {
  stat_date: string
  hours_watched: number
}

export interface queryParams {
  companyId: string
  mediaTypes: string[]
  startDate?: string
  endDate?: string
  excludedInitiativeIDs?: string[]
  includedInitiativeIDs?: string[]
}

export class OTTHoursWatchedStatsModel {
  public async fetchAll({
    companyId,
    mediaTypes,
    startDate,
    endDate,
    excludedInitiativeIDs,
    includedInitiativeIDs,
  }: queryParams): Promise<Report<OTTHoursWatchedStat>> {
    return api('report.dashboards.ihmCompany.ott.hourWatched')
      .params({
        companyId: companyId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_initiative_ids: excludedInitiativeIDs,
        include_initiative_ids: includedInitiativeIDs,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<OTTHoursWatchedStat>>()
  }
}
